// Action Types
export const OPERATION_FAILED = 'OPERATION_FAILED'
export const OPERATION_FAILED_CLEARED = 'OPERATION_FAILED_CLEARED'
